"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRouterLink = exports.getTargetPageData = exports.removeTrailingSlash = void 0;
const isNil_1 = __importDefault(require("lodash/fp/isNil"));
const omitBy_1 = __importDefault(require("lodash/fp/omitBy"));
const libs_language_1 = require("@hotelplan/libs.language");
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const omitNilProps = (0, omitBy_1.default)(isNil_1.default);
function removeTrailingSlash(path) {
    const [pathname, search] = path.split('?');
    const cleanPathname = pathname.replace(/([^\/]+)\/$/, '$1');
    return [cleanPathname, search].filter(Boolean).join('?');
}
exports.removeTrailingSlash = removeTrailingSlash;
function getTargetPageData(internalLink, hiddenQueryParams = {}) {
    if (!internalLink || !internalLink.uri) {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn(`getTargetPageData consumes internalLink or internalLink.uri as null`);
        }
        return null;
    }
    const { uri, targetPageType: pageType } = internalLink;
    let forceLocale = null;
    const as = removeTrailingSlash(uri);
    // eslint-disable-next-line prefer-const,@typescript-eslint/no-unused-vars
    let [pathname, _] = as.split(/[?#]/);
    const [, search = ''] = as.split('?');
    libs_language_1.languageList.some(lang => {
        if (pathname.substring(1).split('/')[0] === lang) {
            forceLocale = lang;
            pathname = pathname.substring(1 + lang.length);
            if (!pathname)
                pathname = '/';
            return true;
        }
    });
    const matchedRoutes = (0, libs_router_config_1.matchAllRoutes)(pathname, r => r.pageType === pageType && (!forceLocale || r.locale === forceLocale));
    let route = matchedRoutes[0];
    let isMatchedByMany = false;
    if (!route) {
        const routesByType = (0, libs_router_config_1.getRoutesByPageType)(pageType);
        if ((routesByType === null || routesByType === void 0 ? void 0 : routesByType.length) === 1) {
            route = routesByType[0];
        }
    }
    else {
        isMatchedByMany = matchedRoutes.length > 1;
    }
    const matched = route === null || route === void 0 ? void 0 : route.matcher(pathname);
    if (!route || !matched) {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn(`Could not find route with path '${pathname}' and pageType '${pageType}'`);
        }
        return null;
    }
    if (route.pageType !== pageType) {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn(`Route ${route.match} has different pageType from ${pageType}`);
        }
    }
    const { params } = matched;
    const routeParams = new URLSearchParams(params);
    const searchParams = new URLSearchParams(search);
    const locale = forceLocale || (!isMatchedByMany && !route.fallback && route.locale);
    // Merge route params + hidden params + search params from asPath
    const pageQueryParams = Object.assign(Object.fromEntries(routeParams), omitNilProps(Object.assign({ locale: matchedRoutes.length > 1 || locale ? undefined : route.locale }, hiddenQueryParams)), Object.fromEntries(searchParams));
    // force locale in page path when locale is false
    // const routePagePath = locale ? route.page : `/${route.locale}${route.page}`;
    const pageQuery = new URLSearchParams(pageQueryParams).toString();
    const pageHref = [route.page, pageQuery].filter(Boolean).join('?');
    return {
        href: pageHref,
        as,
        isExternal: false,
        locale,
    };
}
exports.getTargetPageData = getTargetPageData;
function getRouterLink(link) {
    if (link.__typename === 'ExternalLink') {
        return {
            isExternal: true,
            as: link.url,
            href: link.url,
        };
    }
    return getTargetPageData(link);
}
exports.getRouterLink = getRouterLink;
//# sourceMappingURL=getTargetPageData.js.map